class DCaratDrawer {
  constructor(element) {
    this.element = element;
    this.lastFocus = null;
    document.querySelectorAll(`[data-drawer-open="${element.id}"]`).forEach((button) => button.addEventListener('click', () => this.open(button)));
    element.querySelectorAll('[data-drawer-close]').forEach((button) => button.addEventListener('click', () => this.close()));
    element.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
      if (event.key === 'Tab') this.trapFocus(event);
    });
  }
  open(button) {
    this.lastFocus = button;
    this.element.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    this.element.querySelector('button, a, input')?.focus();
  }
  close() {
    this.element.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    this.lastFocus?.focus();
  }
  trapFocus(event) {
    const focusable = [...this.element.querySelectorAll('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])')].filter((el) => !el.disabled);
    if (!focusable.length) return;
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }
}

const announce = (message) => { const region = document.getElementById('DCaratLiveRegion'); if (region) region.textContent = message; };

async function refreshCart(open = false) {
  const response = await fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`);
  const html = new DOMParser().parseFromString(await response.text(), 'text/html');
  const next = html.getElementById('CartDrawer');
  const current = document.getElementById('CartDrawer');
  if (next && current) { current.replaceWith(next); new DCaratDrawer(next); bindCart(); if (open) document.querySelector('[data-drawer-open="CartDrawer"]')?.click(); }
  const cart = await fetch(`${window.Shopify.routes.root}cart.js`).then((res) => res.json());
  document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; node.hidden = cart.item_count === 0; });
}

function bindCart() {
  document.querySelectorAll('[data-cart-remove]').forEach((button) => button.addEventListener('click', async () => {
    button.disabled = true;
    await fetch(`${window.Shopify.routes.root}cart/change.js`, { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({id: button.dataset.cartRemove, quantity: 0}) });
    refreshCart();
  }));
}

function bindProductForms() {
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
      style: 'currency', currency: window.Shopify?.currency?.active || 'INR', maximumFractionDigits: 0
    }).format(cents / 100);
    const updateVariant = () => {
      const selected = [...form.querySelectorAll('[data-option-group]')].map((group) => group.querySelector('input:checked')?.value);
      const variants = JSON.parse(form.querySelector('[data-variants]').textContent);
      const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
      const id = form.querySelector('[name="id"]');
      const submit = form.querySelector('[data-add-to-cart]');
      form.querySelectorAll('[data-option-group]').forEach((group) => {
        const label = group.querySelector('[data-selected-option]');
        if (label) label.textContent = group.querySelector('input:checked')?.value || '';
      });
      if (!variant) { submit.disabled = true; form.querySelector('[data-add-label]').textContent = 'Unavailable'; return; }
      id.value = variant.id;
      submit.disabled = !variant.available;
      form.querySelector('[data-add-label]').textContent = variant.available ? 'Add to bag' : 'Sold out';
      document.querySelectorAll('[data-product-price], [data-sticky-price]').forEach((node) => { node.textContent = formatMoney(variant.price); });
      const compare = document.querySelector('[data-product-compare-price]');
      if (compare) { compare.hidden = !(variant.compare_at_price > variant.price); compare.textContent = variant.compare_at_price ? formatMoney(variant.compare_at_price) : ''; }
      const stickySubmit = document.querySelector('[data-sticky-submit]');
      if (stickySubmit) { stickySubmit.disabled = !variant.available; stickySubmit.textContent = variant.available ? 'Add to bag' : 'Sold out'; }
      history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
    };
    form.addEventListener('change', updateVariant);
    form.querySelectorAll('[data-quantity-change]').forEach((button) => button.addEventListener('click', () => {
      const input = form.querySelector('[name="quantity"]');
      input.value = Math.max(Number(input.min) || 1, Number(input.value) + Number(button.dataset.quantityChange));
    }));
    document.querySelector('[data-sticky-submit]')?.addEventListener('click', () => form.querySelector('[data-add-to-cart]')?.click());
    form.addEventListener('submit', async (event) => {
      event.preventDefault(); const button = form.querySelector('[type="submit"]'); button.disabled = true;
      try { const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)}); if (!response.ok) throw new Error((await response.json()).description); await refreshCart(true); announce('Added to bag'); }
      catch (error) { announce(error.message); }
      finally { updateVariant(); }
    });
  });
}

function bindProductGallery() {
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const media = [...gallery.querySelectorAll('[data-product-media]')];
    const dots = [...gallery.parentElement.querySelectorAll('[data-gallery-dot]')];
    if (media.length < 2) return;
    dots.forEach((dot, index) => dot.addEventListener('click', () => media[index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })));
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const index = media.indexOf(entry.target);
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      });
    }, { root: gallery, threshold: .65 });
    media.forEach((item) => observer.observe(item));
  });
}

function bindProductWishlist() {
  document.querySelectorAll('[data-pdp-wishlist]').forEach((button) => {
    const key = `dcarat-wishlist-${location.pathname}`;
    const update = (saved) => { button.classList.toggle('is-saved', saved); button.setAttribute('aria-pressed', String(saved)); button.lastChild.textContent = saved ? ' Saved to wishlist' : ' Add to wishlist'; };
    update(localStorage.getItem(key) === 'true');
    button.addEventListener('click', () => { const saved = button.getAttribute('aria-pressed') !== 'true'; localStorage.setItem(key, String(saved)); update(saved); announce(saved ? 'Saved to wishlist' : 'Removed from wishlist'); });
  });
}

function bindPredictiveSearch() {
  document.querySelectorAll('[data-predictive-input]').forEach((input) => {
    let timer;
    input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(async () => {
      const target = document.getElementById(input.getAttribute('aria-controls')); if (!target || input.value.trim().length < 2) { if (target) target.innerHTML = ''; return; }
      target.innerHTML = '<p>Searching…</p>';
      const url = `${window.Shopify.routes.root}search/suggest?q=${encodeURIComponent(input.value)}&resources[type]=product,collection,article,page&section_id=predictive-search`;
      const text = await fetch(url).then((res) => res.text()); target.innerHTML = new DOMParser().parseFromString(text,'text/html').querySelector('#shopify-section-predictive-search')?.innerHTML || '';
    }, 250); });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.drawer').forEach((drawer) => new DCaratDrawer(drawer)); bindCart(); bindProductForms(); bindProductGallery(); bindProductWishlist(); bindPredictiveSearch();
  document.querySelectorAll('.diamond-facets > *').forEach((facet) => facet.setAttribute('pathLength', '1'));
  const form = document.querySelector('[data-product-form]'), sticky = document.querySelector('[data-sticky-atc]');
  if (form && sticky) new IntersectionObserver(([entry]) => {
    sticky.classList.toggle('visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
  }, {threshold:0}).observe(form);
  initLuxuryNavigation();
  initHeroCarousels();
  initRingBuilder();
});

function initHeroCarousels() {
  document.querySelectorAll('[data-hero-carousel]').forEach((carousel) => {
    const slides = [...carousel.querySelectorAll('[data-hero-slide]')];
    const dots = [...carousel.querySelectorAll('[data-hero-dot]')];
    const toggle = carousel.querySelector('[data-hero-toggle]');
    if (slides.length < 2) return;
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const interval = Number(carousel.dataset.interval) || 6000;
    let active = 0, timer, paused = carousel.dataset.autoplay !== 'true' || reducedMotion;

    const show = (index, userInitiated = false) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { const selected = i === active; slide.classList.toggle('is-active', selected); slide.setAttribute('aria-hidden', String(!selected)); slide.querySelectorAll('a').forEach((link) => link.tabIndex = selected ? 0 : -1); });
      dots.forEach((dot, i) => { const selected = i === active; dot.classList.toggle('is-active', selected); dot.setAttribute('aria-selected', String(selected)); });
      if (userInitiated) restart();
    };
    const stop = () => { clearInterval(timer); timer = null; };
    const start = () => { if (!paused) { stop(); timer = setInterval(() => show(active + 1), interval); } };
    const restart = () => { stop(); start(); };
    carousel.querySelector('[data-hero-prev]')?.addEventListener('click', () => show(active - 1, true));
    carousel.querySelector('[data-hero-next]')?.addEventListener('click', () => show(active + 1, true));
    dots.forEach((dot, index) => dot.addEventListener('click', () => show(index, true)));
    toggle?.addEventListener('click', () => { paused = !paused; toggle.classList.toggle('is-paused', paused); toggle.setAttribute('aria-label', paused ? 'Play carousel' : 'Pause carousel'); paused ? stop() : start(); });
    carousel.addEventListener('mouseenter', stop); carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop); carousel.addEventListener('focusout', start);
    carousel.addEventListener('keydown', (event) => { if (event.key === 'ArrowLeft') show(active - 1, true); if (event.key === 'ArrowRight') show(active + 1, true); });
    let touchStart = 0;
    carousel.addEventListener('touchstart', (event) => { touchStart = event.changedTouches[0].clientX; stop(); }, {passive:true});
    carousel.addEventListener('touchend', (event) => { const distance = event.changedTouches[0].clientX - touchStart; if (Math.abs(distance) > 45) show(active + (distance < 0 ? 1 : -1), true); start(); }, {passive:true});
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    show(0); start();
  });
}

function initLuxuryNavigation() {
  const header = document.querySelector('.dc-header');
  const nav = document.querySelector('.dc-nav');
  if (!header || !nav) return;

  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const links = [...nav.querySelectorAll(':scope > li > .dc-nav__link')];
  const gem = document.createElement('span');
  gem.className = 'dc-nav__gem';
  gem.setAttribute('aria-hidden', 'true');
  gem.innerHTML = '<i></i>';
  nav.append(gem);

  const placeGem = (link) => {
    if (!link) { gem.classList.remove('is-visible'); return; }
    const navBox = nav.getBoundingClientRect();
    const box = link.getBoundingClientRect();
    gem.style.setProperty('--gem-x', `${box.left - navBox.left + box.width / 2}px`);
    gem.style.setProperty('--gem-width', `${Math.max(24, box.width)}px`);
    gem.classList.add('is-visible');
  };

  const current = links.find((link) => link.classList.contains('is-current'));
  if (current) requestAnimationFrame(() => placeGem(current));
  const closeAll = (except = null) => {
    nav.querySelectorAll('.has-mega.is-mega-open').forEach((openItem) => {
      if (openItem === except) return;
      openItem.classList.remove('is-mega-open');
      openItem.querySelector(':scope > .dc-nav__link')?.setAttribute('aria-expanded', 'false');
    });
  };
  links.forEach((link) => {
    const item = link.parentElement;
    const mega = item.querySelector('.mega');
    const open = () => { closeAll(item); item.classList.add('is-mega-open'); link.setAttribute('aria-expanded', 'true'); placeGem(link); };
    const close = () => { item.classList.remove('is-mega-open'); link.setAttribute('aria-expanded', 'false'); placeGem(current); };
    item.addEventListener('mouseenter', () => placeGem(link));
    item.addEventListener('mouseleave', () => { if (!item.classList.contains('is-mega-open')) placeGem(current); });
    link.addEventListener('focus', () => placeGem(link));
    if (mega) link.addEventListener('click', (event) => {
      event.preventDefault();
      item.classList.contains('is-mega-open') ? close() : open();
    });
    link.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && mega) { close(); link.focus(); }
      if ((event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') && mega) { event.preventDefault(); open(); mega.querySelector('a')?.focus(); }
    });
  });
  nav.addEventListener('mouseleave', () => placeGem(current));
  addEventListener('resize', () => placeGem(current));
  document.addEventListener('click', (event) => { if (!nav.contains(event.target)) closeAll(); });

  let previousY = scrollY;
  let ticking = false;
  addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const nextY = scrollY;
      header.classList.toggle('is-condensed', nextY > 80);
      header.classList.toggle('is-hidden', nextY > previousY && nextY > 220);
      if (Math.abs(nextY - previousY) > 8) previousY = nextY;
      ticking = false;
    });
  }, {passive:true});

  document.querySelectorAll('.dc-mobile-menu details').forEach((details) => {
    const summary = details.querySelector('summary');
    const content = summary?.nextElementSibling;
    if (!summary || !content || reducedMotion) return;
    summary.addEventListener('click', (event) => {
      event.preventDefault();
      const opening = !details.open;
      if (opening) details.open = true;
      const start = opening ? 0 : content.scrollHeight;
      const end = opening ? content.scrollHeight : 0;
      content.animate([{height:`${start}px`,opacity:opening ? 0 : 1},{height:`${end}px`,opacity:opening ? 1 : 0}], {duration:360,easing:'cubic-bezier(.22,1,.36,1)'}).onfinish = () => {
        if (!opening) details.open = false;
        content.style.height = '';
      };
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const search = document.getElementById('HeaderSearch');
      if (search && !search.hidden) { search.hidden = true; document.querySelector('.dc-action')?.focus(); }
    }
  });
}

function initRingBuilder() {
  document.querySelectorAll('[data-ring-builder-root]').forEach((builder) => {
    const form = builder.querySelector('[data-builder-form]');
    if (!form) return;
    const panes = [...builder.querySelectorAll('[data-builder-pane]')];
    const progress = [...builder.querySelectorAll('[data-builder-progress]')];
    const back = builder.querySelector('[data-builder-back]');
    const next = builder.querySelector('[data-builder-next]');
    const status = builder.querySelector('[data-builder-status]');
    const review = builder.querySelector('[data-builder-review]');
    const whatsapp = builder.querySelector('[data-builder-whatsapp]');
    const engraving = form.elements.Engraving;
    let step = 0;

    const diamondGradient = builder.querySelector('.dc-builder__ring radialGradient');
    const diamondStone = builder.querySelector('.dc-builder__stone');
    if (diamondGradient && diamondStone) diamondStone.style.fill = `url(#${diamondGradient.id})`;

    const values = () => Object.fromEntries(new FormData(form).entries());
    const updatePreview = () => {
      const data = values();
      builder.querySelector('[data-builder-preview-title]').textContent = `${data.Setting} · ${data.Shape}`;
      builder.querySelector('[data-builder-summary="diamond"]').textContent = `${data.Origin} · ${data.Shape} · ${data.Carat}`;
      builder.querySelector('[data-builder-summary="metal"]').textContent = `${data.Karat} ${data.MetalColour}`;
      builder.querySelector('[data-builder-summary="details"]').textContent = `${data.RingSize === 'Not sure' ? 'Size guidance requested' : `US size ${data.RingSize}`} · ${data.Engraving ? `“${data.Engraving}”` : 'No engraving'}`;
      const setting = data.Setting.toLowerCase();
      builder.querySelector('.dc-builder__side-stones').hidden = setting !== 'three stone';
      builder.querySelector('.dc-builder__halo').hidden = setting !== 'halo';
      builder.querySelector('.dc-builder__pave').hidden = setting !== 'pavé';
      const colors = { 'White Gold': ['#e9eef0','#ffffff','#aebdc1','#f5f7f7'], 'Yellow Gold': ['#a66f16','#ffe5a1','#bc8121','#f9d47a'], 'Rose Gold': ['#a96658','#f5c2b5','#b87868','#f1b8aa'] };
      const stops = builder.querySelectorAll('.dc-builder__ring linearGradient stop');
      (colors[data.MetalColour] || colors['White Gold']).forEach((color, index) => stops[index]?.setAttribute('stop-color', color));
      if (engraving) builder.querySelector('[data-engraving-count]').textContent = engraving.value.length;
      try { sessionStorage.setItem('dcarat-ring-design', JSON.stringify(data)); } catch (error) {}
    };

    const buildReview = () => {
      const data = values();
      const rows = [
        ['Setting', data.Setting], ['Diamond', `${data.Origin} ${data.Shape}`], ['Carat preference', data.Carat],
        ['Colour & clarity', `${data.Colour} · ${data.Clarity}`], ['Metal', `${data.Karat} ${data.MetalColour}`],
        ['Ring size', data.RingSize === 'Not sure' ? 'Specialist guidance requested' : `US ${data.RingSize}`], ['Engraving', data.Engraving || 'None']
      ];
      review.replaceChildren(...rows.map(([label, value]) => { const row = document.createElement('div'), dt = document.createElement('span'), dd = document.createElement('strong'); dt.textContent = label; dd.textContent = value; row.append(dt, dd); return row; }));
      const message = [`Hello D'Carat, I would like to refine this ring design:`, ...rows.map(([label, value]) => `${label}: ${value}`), 'Please confirm compatible certified diamonds and final pricing.'].join('\n');
      const base = (builder.dataset.whatsappUrl || 'https://wa.me/13332693480').split('?')[0];
      whatsapp.href = `${base}?text=${encodeURIComponent(message)}`;
    };

    const show = (index, focus = false) => {
      step = Math.max(0, Math.min(index, panes.length - 1));
      panes.forEach((pane, paneIndex) => { const active = paneIndex === step; pane.hidden = !active; pane.classList.toggle('is-active', active); });
      progress.forEach((item, itemIndex) => { item.classList.toggle('is-active', itemIndex === step); item.classList.toggle('is-complete', itemIndex < step); if (itemIndex === step) item.setAttribute('aria-current', 'step'); else item.removeAttribute('aria-current'); });
      back.disabled = step === 0;
      next.hidden = step === panes.length - 1;
      status.textContent = `Step ${step + 1} of ${panes.length}`;
      if (step === panes.length - 1) buildReview();
      if (focus) panes[step].querySelector('h2')?.focus({ preventScroll: true });
      builder.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    };

    try {
      const saved = JSON.parse(sessionStorage.getItem('dcarat-ring-design') || '{}');
      Object.entries(saved).forEach(([name, value]) => { const control = [...form.elements].find((item) => item.name === name && (item.value === value || item.type !== 'radio')); if (control) { if (control.type === 'radio') control.checked = true; else control.value = value; } });
    } catch (error) {}
    form.addEventListener('change', updatePreview);
    form.addEventListener('input', updatePreview);
    next.addEventListener('click', () => show(step + 1, true));
    back.addEventListener('click', () => show(step - 1, true));
    progress.forEach((item, index) => item.addEventListener('click', () => { if (index <= step || index === step + 1) show(index, true); }));
    builder.querySelector('[data-builder-restart]')?.addEventListener('click', () => { form.reset(); try { sessionStorage.removeItem('dcarat-ring-design'); } catch (error) {} updatePreview(); show(0, true); });
    updatePreview(); show(0);
  });
}
